// extracted by mini-css-extract-plugin
export default {"item":"_3-Emg"};